"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.LegalDisclaimerSchema = void 0;
exports.LegalDisclaimerSchema = {
    "$id": "https://www.redbull.com/schemas/attributes/legal-disclaimer.schema.json",
    "$schema": "https://json-schema.org/draft/2020-12/schema",
    "title": "LegalDisclaimer",
    "description": "For legal reasons we are obliged to add legal language in some markets",
    "type": "object",
    "additionalProperties": false,
    "properties": {
        "type": {
            "type": "string",
            "enum": [
                "attributes:legal-disclaimer"
            ]
        },
        "legalText": {
            "$ref": "https://www.redbull.com/schemas/attributes/textual-artefact-container.schema.json"
        }
    },
    "required": [
        "type",
        "legalText"
    ]
};
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoibGVnYWwtZGlzY2xhaW1lci5zY2hlbWEuanMiLCJzb3VyY2VSb290IjoiIiwic291cmNlcyI6WyIuLi8uLi8uLi9zcmMvbW9kdWxlcy9hdHRyaWJ1dGVzL2xlZ2FsLWRpc2NsYWltZXIuc2NoZW1hLnRzIl0sIm5hbWVzIjpbXSwibWFwcGluZ3MiOiI7OztBQUFhLFFBQUEscUJBQXFCLEdBQUc7SUFDbkMsS0FBSyxFQUFFLHlFQUF5RTtJQUNoRixTQUFTLEVBQUUsOENBQThDO0lBQ3pELE9BQU8sRUFBRSxpQkFBaUI7SUFDMUIsYUFBYSxFQUFFLHdFQUF3RTtJQUN2RixNQUFNLEVBQUUsUUFBUTtJQUNoQixzQkFBc0IsRUFBRSxLQUFLO0lBQzdCLFlBQVksRUFBRTtRQUNaLE1BQU0sRUFBRTtZQUNOLE1BQU0sRUFBRSxRQUFRO1lBQ2hCLE1BQU0sRUFBRTtnQkFDTiw2QkFBNkI7YUFDOUI7U0FDRjtRQUNELFdBQVcsRUFBRTtZQUNYLE1BQU0sRUFBRSxtRkFBbUY7U0FDNUY7S0FDRjtJQUNELFVBQVUsRUFBRTtRQUNWLE1BQU07UUFDTixXQUFXO0tBQ1o7Q0FDRixDQUFBIn0=